import Enums from '@core/types/api/Enums';
import type { Product } from '@core/types/api/Product/Product';
import { useSlabQuery } from '@web/hooks/useSlabQuery';

export type ProductPerPlant = {
  plantName: string;
  plantId: string;
  match: Product[];
  notMatch: string[];
};

const productsPerPlants = (
  quoteProductNames: string[],
  plantProducts: Product[],
): ProductPerPlant[] => {
  const plantMap: { [plantId: string]: ProductPerPlant } = {};
  plantProducts.forEach((product) => {
    if (!plantMap[product.plant.id]) {
      plantMap[product.plant.id] = {
        match: [],
        notMatch: [],
        plantId: product.plant.id,
        plantName: product.plant.name,
      };
    }
    plantMap[product.plant.id].match.push(product);
  });
  const plants = Object.keys(plantMap).map((plantId) => plantMap[plantId]);
  return plants.map((plant) => {
    const matchNames = plant.match.map((product) => product.alternateID);
    return {
      ...plant,
      notMatch: quoteProductNames.filter((productName) => !matchNames.includes(productName)),
    };
  });
};

export const useLocationProductsGrouping = (
  excludePlantIds: string[],
  productNames: string[],
): { isLoading: boolean; plants: ProductPerPlant[] } => {
  const { data, isLoading } = useSlabQuery('GET products', {
    queryParams: {
      filterBy: [
        {
          name: 'alternateId',
          operation: Enums.FilterOperation.Equals,
          values: productNames,
        },
        {
          name: 'plantId',
          operation: Enums.FilterOperation.NotEquals,
          values: excludePlantIds,
        },
      ],
      perPage: 0,
      page: 0,
    },
  });
  if (isLoading) {
    return {
      isLoading: true,
      plants: [],
    };
  }
  return {
    isLoading: false,
    plants: productsPerPlants(productNames, data?.items || []),
  };
};
